__turbopack_context__.v({
  "innerContainer": "DocumentBulkActionBar-module__4N7HZa__innerContainer",
  "outerContainer": "DocumentBulkActionBar-module__4N7HZa__outerContainer",
});
